(ns ui.animation-editor.page
  "The Replicant story template (animation) editor under
   /ui/animation-editor. Opened by the gallery cards and the agenda; the
   old hash routes /#/instagram/story/animation/{new,edit}/<eid> of the
   former Reagent editor redirect here."
  (:require [parts.replicant.query :as query]
            [ui.animation-editor.ui :as ui]
            [ui.app-frame :as app-frame]
            [ui.navbar :as navbar]
            [ui.sidebar :as sidebar]
            [ui.user-session :as user-session]))

(defn frame
  "Navbar and sidebar around the `content`, which takes the full width:
   the stage and the settings need more room than the container of
   `ui.app-frame/app-frame` offers."
  [state content]
  (if (query/loading? state app-frame/user-session-query)
    [:div "loading..."]
    ;; `h-full` instead of `h-dvh`, which browsers without the `dvh`
    ;; unit (Chrome < 108) drop (see `ui.gallery.page/frame`):
    [:div.flex.flex-col.h-full
     (navbar/navbar state)
     [:main.flex-1.min-h-0.overflow-hidden
      [:div.flex.h-full.relative.overflow-hidden
       (sidebar/sidebar-toggle state)
       (when-not (:ui/hide-side-menu? state)
         (sidebar/sidebar state))
       [:div.flex.flex-col.grow.min-w-0.min-h-0.overflow-y-auto.bg-gray-100
        content]]]
     (when-not (:ui/hide-side-menu? state)
       (app-frame/book-call-button (user-session/org-uuid state)))]))

(defn hint
  [message]
  [:div.p-4.text-gray-500
   message])

(defn render
  [state]
  (let [editor (:animation-editor state)]
    (frame state
           (case (:status editor)
             :ready (ui/panel editor)
             :missing (hint "This story template no longer exists.")
             :error (hint "The story template could not be loaded. Please reload the page.")
             (hint "Loading...")))))

(def page
  {:page-id :pages/animation-editor
   :route [["ui" "animation-editor"]]
   :on-load (fn [location]
              [[:ui/hide-sidebar-on-mobile]
               [:animation-editor/init location]])
   :render #'render})
